import React, { useRef, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Box from '@material-ui/core/Box'
import { default as TextField, MenuProps } from './../../textfield'
import MenuItem from '@material-ui/core/MenuItem'
import { floorsByBuilding, areasByBuildingFloor } from './../selectors'
import { selectBuilding, selectFloor, selectArea } from './../../../actions/workspace'

// Props shared between the filtering text fields
const sharedFilterProps = (ref) => ({
  select: true,
  margin: 'none',
  variant: 'filled',
  fullWidth: true,
  SelectProps: { MenuProps: { ...MenuProps, marginThreshold: 0 } }
})

const Mobile = ({ disableFilter, buildings, floors, areas, selected, onBuildingSelect, onFloorSelect, onAreaSelect }) => {
  const buildingContainer = useRef()

  return (
    <React.Fragment>
      <Box ref={buildingContainer}>
        <TextField
          label={'Building'}
          disabled={disableFilter}
          value={selected.building || 0}
          onChange={(e) => onBuildingSelect(e.target.value)}
          {...sharedFilterProps(buildingContainer.current)}>
          <MenuItem value={0}>All</MenuItem>
          {buildings.map((option, index) => (
            <MenuItem key={`${option.id}-${index}`} value={option.id}>
              {option.name}
            </MenuItem>))}
        </TextField>
      </Box>
      <Box>
        <TextField
          disabled={disableFilter || !(selected.building)}
          label={'Floor'}
          value={selected.floor || 0}
          onChange={(e) => onFloorSelect(e.target.value)}
          {...sharedFilterProps(buildingContainer.current)}>
          <MenuItem value={0}>All</MenuItem>
          {floors.map((option, index) => (
            <MenuItem key={`${option.id}-${index}`} value={option.id}>
              {option.name}
            </MenuItem>))}
        </TextField>
      </Box>
      <Box>
        <TextField
          disabled={disableFilter || !(selected.floor)}
          label={'Area'}
          value={selected.area || 0}
          onChange={(e) => onAreaSelect(e.target.value)}
          {...sharedFilterProps(buildingContainer.current)}>
          <MenuItem value={0}>All</MenuItem>
          {areas.map((option, index) => (
            <MenuItem key={`${option.id}-${index}`} value={option.id}>
              {option.name}
            </MenuItem>))}
        </TextField>
      </Box>
    </React.Fragment>
  )
}

Mobile.defaultProps = {
  selected: {},
  buildings: [],
  floors: [],
  areas: []
}

export default Mobile

export const Connected = (props) => {
  const dispatch = useDispatch()

  props = {
    ...props,
    selected: useSelector((state) => state._workspace.selected),
    buildings: useSelector((state) => state.workspace.buildings),
    floors: useSelector(floorsByBuilding),
    areas: useSelector(areasByBuildingFloor),
    onBuildingSelect: useCallback((building) => dispatch(selectBuilding(building)), [dispatch]),
    onFloorSelect: useCallback((floor) => dispatch(selectFloor(floor)), [dispatch]),
    onAreaSelect: useCallback((area) => dispatch(selectArea(area)), [dispatch])
  }

  return <Mobile {...props} />
}